{
  "version": 1,
  "asset_id": "531787ee-0b65-41a1-8bd5-68096b9676fa",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/531787ee-0b65-41a1-8bd5-68096b9676fa/texas-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/531787ee-0b65-41a1-8bd5-68096b9676fa/texas-1280.avif",
  "original_filename": "texas-1280.avif",
  "size": 33601,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:05Z"
}
